/* 太史慈傳・第 4 章：海昏・建昌（199–206 年）
 * 東邊是治所海昏，北邊是建昌，西邊是艾、西安兩縣；劉磐的兵從西邊（往長沙的山路）三條路下來。 */
export const HAIHUN = [6900, 2700];
export const COUNTIES = [
  { id: 'ai', name: '艾', x: 2300, y: 1500 },
  { id: 'xian', name: '西安', x: 2600, y: 3900 },
  { id: 'jc', name: '建昌', x: 5400, y: 1000 },
  { id: 'hh', name: '海昏', x: HAIHUN[0], y: HAIHUN[1] },
];
export const WEST = { ai: [250, 1300], mid: [250, 2700], xian: [250, 4000] };
export const FORK = [4500, 2700];
export default {
  id: 'taishici_haihun', name: '海昏', W: 8400, H: 5000, seed: 199,
  bases: [HAIHUN, WEST.mid],
  roads: [
    { pts: [HAIHUN, FORK, [3300, 2200], [2300, 1500], WEST.ai], w: 140 },
    { pts: [FORK, [3500, 3300], [2600, 3900], WEST.xian], w: 140 },
    { pts: [HAIHUN, [6300, 1600], [5400, 1000], [3800, 1100], [2300, 1500]], w: 120 },
    { pts: [WEST.mid, [1500, 2700], [2300, 1500]], w: 110 }, { pts: [[1500, 2700], [2600, 3900]], w: 110 },
  ],
  rocks: [[1000, 2000, 320, 200], [1000, 3400, 320, 200], [3900, 2000, 260, 140], [5600, 2300, 300, 150], [4300, 4200, 380, 180], [7600, 1000, 300, 160], [7600, 4300, 360, 180], [3400, 300, 400, 140]],
  woods: 0.45,
  sight: 0.85,
  clearings: [[HAIHUN[0], HAIHUN[1], 600], [2300, 1500, 420], [2600, 3900, 420], [5400, 1000, 420], [FORK[0], FORK[1], 300]],
  villages: [{ x: 2300, y: 1400, n: 5, r: 320 }, { x: 2600, y: 3800, n: 5, r: 320 }, { x: 5400, y: 900, n: 5, r: 320 }, { x: HAIHUN[0] + 250, y: HAIHUN[1] + 200, n: 6, r: 360 }],
  tents: [{ x: HAIHUN[0] - 200, y: HAIHUN[1] - 150, n: 5, r: 280, chief: true, col: '#b8433a', flag: '史' }],
  fields: [[3000, 3000, 420, 200], [5800, 3400, 480, 220], [4400, 1500, 380, 180]],
  marsh: [[7800, 2600, 300, 400]], // 東邊近彭蠡澤
  shops: [[HAIHUN[0] + 150, HAIHUN[1] + 120]],
};
